export default __webpack_public_path__ + "static/media/dotty.c0b0a500.png";